import type { CardHooks, CardHookCtx } from "./registry";

/**
 * Hookfang Shiv — equipment passive.
 *
 * When ANY attack (attack/defend card, equipment, or signature) you played
 * this round has the Chain keyword AND dealt damage, Hookfang Shiv itself
 * gains Chain the next time YOU play it as an attack this round.
 *
 * Implementation note: fires on `onDamageDealt`, which the engine loops over
 * every equipped item via getAnyHooksByName. The hook checks the attack card
 * (not Hookfang itself) for Chain. If matched, it returns
 * grantSelfEquipSlotKeyword targeting Hookfang's own equip slot — that adds
 * "Chain" to the slot's pendingKeywordGrants list, which playEquip merges
 * into the combat slot's attackGrantedKeywords the next time the equipment
 * is played. Cleared automatically at round start.
 */
export const hookfangShiv: CardHooks = {
  onDamageDealt: (ctx: CardHookCtx) => {
    if (!ctx.attackCard || (ctx.damageDealt ?? 0) <= 0) return {};

    const attackHasChain =
      (ctx.attackCard.keywords ?? []).some((k) => k.toLowerCase() === "chain") ||
      (ctx.attackCard.attackKeywords ?? []).some((k) => k.toLowerCase() === "chain");

    if (!attackHasChain) return {};

    // Find which equip slot Hookfang Shiv sits in for this player.
    const slotIdx = ctx.self.equipSlots.findIndex((s) => s.cardId === ctx.card.id);
    if (slotIdx < 0) return {};

    return {
      grantSelfEquipSlotKeyword: { slotIdx, keyword: "Chain" },
      log: [`${ctx.card.name} gains Chain for the rest of the round.`],
    };
  },
};
